import MainNavigfation from '../components/MainNavigation';

function ErrorPage() {
	return (
		<>
			<MainNavigfation />
			<main>
				<h1>An error occured!</h1>
				<p>Could not find this page!</p>
			</main>
		</>
	);
}

export default ErrorPage;
